import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import axios from "axios";
import { localApi, credentials } from "utils/imgApi";

import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";

import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import CornerRibbon from "react-corner-ribbon";

import { makeStyles } from "@material-ui/core/styles";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";

import { AiOutlineFolderView } from "react-icons/ai";
import Tooltip from "@material-ui/core/Tooltip";
import Edit from "@material-ui/icons/Edit";

import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import styDrop from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import styHoever from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";

import SweetAlert from "react-bootstrap-sweetalert";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

import {
  Favorite,
  FavoriteBorder,
  ChatBubbleOutline,
  Repeat,
  ShareOutlined,
  Phone,
  WhatsApp,
  Bookmark,
  BookmarkBorder,
  MoreHoriz,
  Send,
  Delete,
  Close,
} from "@material-ui/icons";

// Material UI Dialog
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Divider from "@material-ui/core/Divider";
import CircularProgress from "@material-ui/core/CircularProgress";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const useStyles = makeStyles(styles);
const useStyl = makeStyles(styDrop);
const useHoever = makeStyles(styHoever);
const useStyleSweet = makeStyles(styleSweet);

export default function ViewPosts(props) {
  const [posts, setPosts] = React.useState([]);
  const [ribbonColors, setRibbonColors] = useState({});

  const [alertType, alertTypeOps] = React.useState("");
  const [alertMsg, alertMsgOps] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);
  const [submitteds, setSubmitteds] = React.useState(false);
  const [submittedConfirm, setSubmittedConfirm] = React.useState(false);

  // =========================================================
  // COMMENT DIALOG STATES
  // =========================================================

  const [commentDialogOpen, setCommentDialogOpen] = useState(false);

  const [selectedPost, setSelectedPost] = useState(null);

  const [commentText, setCommentText] = useState("");

  const [comments, setComments] = useState([]);

  const [commentsLoading, setCommentsLoading] = useState(false);

  const [commentSubmitting, setCommentSubmitting] = useState(false);

  // =========================================================
  // SELECTED COMMENT CHECKBOXES
  // =========================================================

  const [selectedComments, setSelectedComments] = useState([]);

  const classes = useStyles();
  const classe = useStyl();
  const classeHover = useHoever();
  const classSweet = useStyleSweet();

  const history = useHistory();

  const activeSession = sessionStorage.getItem("sessionData");

  const { state } = useLocation();

  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  // =========================================================
  // CONVERT
  // =========================================================

  function convertToNextTenth(num) {
    return (Math.ceil(num * 10) / 10).toFixed(2);
  }

  // =========================================================
  // GET POSTS
  // =========================================================

  async function getUsers() {
    try {
      const api = localApi + `/posts/list/byAdminId/${userObj && userObj.id}`;

      const result = await fetch(api, {
        method: "GET",
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      });

      const getResult = await result.json();

      setPosts(getResult && getResult);
    } catch (error) {
      console.error("Error getting posts:", error);
    }
  }

  useEffect(() => {
    getUsers();
  }, []);

  // =========================================================
  // ALERT
  // =========================================================

  const hideAlert = () => {
    setSubmitted(false);
    window.location.reload(false);
  };

  const hideAlerts = () => {
    setSubmitteds(false);
    setSubmittedConfirm(false);
    window.location.reload(false);
  };

  // =========================================================
  // OPEN COMMENTS
  // =========================================================

  const openComments = async (post) => {
    setSelectedPost(post);

    setCommentDialogOpen(true);

    setCommentText("");

    setSelectedComments([]);

    setComments([]);

    await getComments(post.id);
  };

  // =========================================================
  // CLOSE COMMENTS
  // =========================================================

  const closeComments = () => {
    setCommentDialogOpen(false);

    setSelectedPost(null);

    setCommentText("");

    setComments([]);

    setSelectedComments([]);
  };

  // =========================================================
  // GET COMMENTS
  // =========================================================

  const getComments = async (postId) => {
    if (!postId) {
      return;
    }

    try {
      setCommentsLoading(true);

      /*
       * YOUR COMMENT GET API
       *
       * Change only this URL if your backend endpoint
       * is different.
       */
      const api = `${localApi}/posts/allListComment/byAdminAndPostsId/${postId}/${userObj.id}`;

      const result = await fetch(api, {
        method: "GET",
        headers: {
          Authorization: `Basic ${credentials}`,
          "Content-Type": "application/json",
        },
      });

      if (!result.ok) {
        throw new Error(`Failed to get comments: ${result.status}`);
      }

      const data = await result.json();

      if (Array.isArray(data)) {
        setComments(data);
      } else if (Array.isArray(data?.comments)) {
        setComments(data.comments);
      } else if (Array.isArray(data?.commentList)) {
        setComments(data.commentList);
      } else {
        setComments([]);
      }
    } catch (error) {
      console.error("Error getting comments:", error);

      setComments([]);
    } finally {
      setCommentsLoading(false);
    }
  };

  // =========================================================
  // CHECKBOX - SINGLE COMMENT
  // =========================================================

  const handleCommentCheckbox = (commentId) => {
    if (!commentId) {
      return;
    }

    setSelectedComments((previous) => {
      if (previous.includes(commentId)) {
        return previous.filter((id) => id !== commentId);
      }

      return [...previous, commentId];
    });
  };

  // =========================================================
  // CHECKBOX - SELECT ALL
  // =========================================================

  const handleSelectAllComments = () => {
    if (!comments || comments.length === 0) {
      return;
    }

    const allIds = comments.map(
      (comment, index) =>
        comment.id || comment.commentId || comment.rId || `comment-${index}`,
    );

    setSelectedComments(allIds);
  };

  // =========================================================
  // CHECKBOX - CLEAR ALL
  // =========================================================

  const handleClearAllComments = () => {
    setSelectedComments([]);
  };

  // =========================================================
  // CHECK IF ALL SELECTED
  // =========================================================

  const allCommentsSelected =
    comments.length > 0 && selectedComments.length === comments.length;

  // =========================================================
  // DELETE SELECTED COMMENTS
  // =========================================================

  const handleDeleteSelectedComments = async () => {
    if (selectedComments.length === 0) {
      return;
    }

    const confirmDelete = window.confirm(
      `Delete ${selectedComments.length} selected comment${
        selectedComments.length > 1 ? "s" : ""
      }?`,
    );

    if (!confirmDelete) {
      return;
    }

    try {
      /*
       * If you already have a delete-comment API,
       * connect it here.
       *
       * Example:
       *
       * for (const commentId of selectedComments) {
       *   await fetch(
       *     `${localApi}/posts/comment/delete/${commentId}`,
       *     {
       *       method: "DELETE",
       *       headers: {
       *         Authorization: `Basic ${credentials}`,
       *       },
       *     }
       *   );
       * }
       */

      console.log("Selected comment IDs:", selectedComments);

      // Remove from UI
      setComments((previous) =>
        previous.filter((comment, index) => {
          const commentId =
            comment.id ||
            comment.commentId ||
            comment.rId ||
            `comment-${index}`;

          return !selectedComments.includes(commentId);
        }),
      );

      setSelectedComments([]);
    } catch (error) {
      console.error("Error deleting selected comments:", error);
    }
  };

  // =========================================================
  // ADD COMMENT
  // =========================================================

  const handleAddComment = async () => {
    const text = commentText.trim();

    if (!text) {
      return;
    }

    if (!selectedPost?.id) {
      return;
    }

    if (!userObj?.id) {
      alert("Please login first.");
      return;
    }

    try {
      setCommentSubmitting(true);

      /*
       * YOUR COMMENT POST API
       *
       * Change only this URL/body if your Spring Boot
       * endpoint is different.
       */
      const api = `${localApi}/posts/comment/${selectedPost.id}/${userObj.id}`;

      const result = await fetch(api, {
        method: "POST",
        headers: {
          Authorization: `Basic ${credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          comment: text,
          description: text,
          text: text,
        }),
      });

      if (!result.ok) {
        throw new Error(`Failed to add comment: ${result.status}`);
      }

      setCommentText("");

      await getComments(selectedPost.id);

      // Update count on post
      setPosts((previousPosts) =>
        previousPosts.map((item) =>
          item.id === selectedPost.id
            ? {
                ...item,
                comments: Number(item.comments || 0) + 1,
              }
            : item,
        ),
      );
    } catch (error) {
      console.error("Error adding comment:", error);
    } finally {
      setCommentSubmitting(false);
    }
  };

  // =========================================================
  // ENTER TO SEND
  // =========================================================

  const handleCommentKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();

      handleAddComment();
    }
  };

  // =========================================================
  // CARD STYLE
  // =========================================================

  const cardStyle = {
    width: "100%",
    height: "auto",
    margin: 0,
    padding: 0,
    borderRadius: 12,
    overflow: "hidden",
    backgroundColor: "#ffffff",
    boxShadow: "0 4px 14px rgba(0, 0, 0, 0.10)",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    marginBottom: 20,
  };

  const headerRowStyle = {
    display: "flex",
    alignItems: "center",
    minHeight: 65,
    padding: "12px 16px",
    background: "#fafafa",
    borderBottom: "1px solid #eeeeee",
    flexShrink: 0,
    boxSizing: "border-box",
  };

  // =========================================================
  // AVATAR
  // =========================================================

  const AvatarImage = ({ src, company }) => {
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
      setHasError(false);
    }, [src]);

    if (!src || hasError) {
      return <AvatarFallback company={company} />;
    }

    return (
      <img
        src={src}
        alt={company || "Company avatar"}
        title={company || "Company"}
        style={{
          width: 40,
          height: 40,
          minWidth: 40,
          borderRadius: "50%",
          marginRight: 12,
          objectFit: "cover",
          border: "1px solid #eeeeee",
        }}
        onError={() => setHasError(true)}
      />
    );
  };

  // =========================================================
  // AVATAR FALLBACK
  // =========================================================

  const AvatarFallback = ({ company, style }) => {
    return (
      <div
        aria-label={company || "Company avatar"}
        title={company || "Company"}
        style={{
          width: 40,
          height: 40,
          minWidth: 40,
          borderRadius: "50%",
          marginRight: 12,
          border: "1px solid #eeeeee",
          backgroundColor: "#e0e0e0",
          color: "#262626",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 14,
          fontWeight: 700,
          overflow: "hidden",
          ...style,
        }}
      >
        {getInitials(company)}
      </div>
    );
  };

  // =========================================================
  // INITIALS
  // =========================================================

  const getInitials = (company) => {
    if (!company || typeof company !== "string") {
      return "?";
    }

    const words = company.trim().split(/\s+/).filter(Boolean);

    if (words.length === 0) {
      return "?";
    }

    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase();
    }

    return `${words[0].charAt(0)}${words[1].charAt(0)}`.toUpperCase();
  };

  // =========================================================
  // IMAGE
  // =========================================================

  const imageWrapperStyle = {
    position: "relative",
    height: 260,
    width: "100%",
    overflow: "hidden",
    background: "#f5f5f5",
    flexShrink: 0,
  };

  const imageStyle = {
    display: "block",
    width: "100%",
    height: "100%",
    objectFit: "cover",
  };

  // =========================================================
  // RIBBONS
  // =========================================================

  const ribbonTopStyle = {
    position: "absolute",
    top: 12,
    left: "50%",
    transform: "translateX(-50%)",
    color: "#ffffff",
    padding: "6px 10px",
    borderRadius: 5,
    fontSize: 11,
    lineHeight: "14px",
    fontWeight: 700,
    whiteSpace: "nowrap",
    transition: "background 0.3s ease",
    zIndex: 2,
  };

  const ribbonBottomStyle = {
    position: "absolute",
    bottom: 12,
    left: 12,
    background: "rgba(218, 165, 32, 0.93)",
    color: "#111111",
    padding: "6px 14px",
    borderRadius: 5,
    fontSize: 12,
    lineHeight: "14px",
    fontWeight: 700,
    whiteSpace: "nowrap",
    zIndex: 2,
  };

  const ribbonCategoryStyle = {
    position: "absolute",
    top: "50%",
    right: 12,
    transform: "translateY(-50%)",
    background: "rgba(0, 0, 0, 0.55)",
    color: "#ffffff",
    padding: "6px 10px",
    borderRadius: 5,
    fontSize: 12,
    lineHeight: "14px",
    fontWeight: 700,
    textAlign: "center",
    whiteSpace: "nowrap",
    zIndex: 2,
  };

  // =========================================================
  // CAPTION
  // =========================================================

  const captionStyle = {
    color: "#262626",
    fontSize: 13,
    lineHeight: "19px",
  };

  const hashtagStyle = {
    color: "#505050",
    fontSize: 13,
    lineHeight: "18px",
    marginTop: 2,
  };

  // =========================================================
  // IMAGE COLOR
  // =========================================================

  const handleImageLoad = (event, postId) => {
    try {
      const image = event.target;

      const canvas = document.createElement("canvas");

      const context = canvas.getContext("2d");

      if (!context) {
        throw new Error("Canvas context is not available");
      }

      const sampleSize = 50;

      canvas.width = sampleSize;

      canvas.height = sampleSize;

      context.drawImage(image, 0, 0, sampleSize, sampleSize);

      const imageData = context.getImageData(0, 0, sampleSize, sampleSize);

      let redTotal = 0;
      let greenTotal = 0;
      let blueTotal = 0;

      let pixelCount = 0;

      for (let index = 0; index < imageData.data.length; index += 4) {
        const red = imageData.data[index];

        const green = imageData.data[index + 1];

        const blue = imageData.data[index + 2];

        const alpha = imageData.data[index + 3];

        if (alpha < 100) {
          continue;
        }

        if (red > 245 && green > 245 && blue > 245) {
          continue;
        }

        redTotal += red;

        greenTotal += green;

        blueTotal += blue;

        pixelCount += 1;
      }

      if (pixelCount === 0) {
        throw new Error("No usable image pixels");
      }

      const red = Math.round(redTotal / pixelCount);

      const green = Math.round(greenTotal / pixelCount);

      const blue = Math.round(blueTotal / pixelCount);

      setRibbonColors((previous) => ({
        ...previous,
        [postId]: `rgba(${red}, ${green}, ${blue}, 0.88)`,
      }));
    } catch (error) {
      setRibbonColors((previous) => ({
        ...previous,
        [postId]: "rgba(0, 0, 0, 0.55)",
      }));
    }
  };

  // =========================================================
  // ACTION STYLES
  // =========================================================

  // const actionsRowStyle = {
  //   display: "flex",
  //   alignItems: "center",
  //   justifyContent: "space-between",
  //   minHeight: 52,
  //   padding: "8px 10px",
  //   flexShrink: 0,
  // };

  // const leftActionsStyle = {
  //   display: "flex",
  //   alignItems: "center",
  //   gap: 0,
  //   overflow: "hidden",
  // };

  // const actionWithValueStyle = {
  //   display: "flex",
  //   alignItems: "center",
  //   marginRight: 2,
  // };

  // const actionCountStyle = {
  //   color: "#444444",
  //   fontSize: 11,
  //   fontWeight: 600,
  //   marginLeft: -5,
  //   marginRight: 2,
  //   whiteSpace: "nowrap",
  // };

  const actionsRowStyle = {
    display: "flex",
    width: "100%",
    minHeight: 52,
    padding: "6px 8px",
    boxSizing: "border-box",
    flexShrink: 0,
    overflow: "visible",
  };

  const leftActionsStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    flexWrap: "wrap",
    rowGap: 2,
    columnGap: 2,
    overflow: "visible",
  };

  const actionWithValueStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: "0 1 auto",
    minWidth: 42,
    height: 34,
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
    whiteSpace: "nowrap",
  };

  const actionButtonStyle = {
    width: 30,
    minWidth: 30,
    height: 32,
    minHeight: 32,
    padding: 0,
    margin: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  };

  const actionIconStyle = {
    color: "#262626",
    fontSize: 19,
    width: 19,
    height: 19,
    flexShrink: 0,
  };

  const actionCountStyle = {
    color: "#444444",
    fontSize: 10,
    fontWeight: 600,
    marginLeft: 1,
    whiteSpace: "nowrap",
    flexShrink: 0,
  };

  // =========================================================
  // COMMENT DIALOG STYLES
  // =========================================================

  const commentListStyle = {
    maxHeight: 350,
    overflowY: "auto",
    padding: "4px 0",
  };

  const timeStyle = {
    // marginLeft: 8,
    color: "#8e8e8e",
    fontSize: 12,
  };

  // =========================================================
  // RENDER
  // =========================================================

  return (
    <div
      style={{
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      {/* =====================================================
          POSTS GRID
      ===================================================== */}

      <GridContainer
        style={{
          marginLeft: 0,
          marginRight: 0,
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        {posts.map((post) => {
          const endDate = post.endDate ? new Date(post.endDate) : null;
          const createDate = post.createDate ? new Date(post.createDate) : null;

          let timeAgo = "";

          if (createDate) {
            const now = new Date();
            const diffMs = now - createDate;

            const minutes = Math.floor(diffMs / (1000 * 60));
            const hours = Math.floor(diffMs / (1000 * 60 * 60));
            const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
            const months = Math.floor(days / 30);

            if (months >= 1) {
              timeAgo = `${months} month ago`;
            } else if (days >= 1) {
              timeAgo = `${days} days ago`;
            } else if (hours >= 1) {
              timeAgo = `${hours} hours ago`;
            } else if (minutes >= 1) {
              timeAgo = `${minutes} min ago`;
            } else {
              timeAgo = "Just now";
            }
          }

          // console.log(timeAgo);

          const isOfferActive =
            endDate && !Number.isNaN(endDate.getTime())
              ? endDate.getTime() >= Date.now()
              : false;

          const isReposted =
            typeof post.isReposted === "boolean"
              ? post.isReposted
              : Boolean(post.isReposts);

          return (
            <GridItem
              key={post.id}
              xs={12}
              sm={6}
              md={4}
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "8px",
                boxSizing: "border-box",
              }}
            >
              <Card style={cardStyle}>
                {/* =================================================
                    HEADER
                ================================================= */}

                <div style={headerRowStyle}>
                  <AvatarImage src={post.avatarUrl} company={post.company} />

                  <div
                    style={{
                      flex: 1,
                      minWidth: 0,
                    }}
                  >
                    <div
                      style={{
                        color: "#262626",
                        fontSize: 14,
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {post.company || "Company"}
                    </div>

                    <div
                      style={{
                        marginTop: 2,
                        color: "#8e8e8e",
                        fontSize: 12,
                      }}
                    >
                      Mumbai, India
                    </div>
                  </div>

                  <Tooltip title="More options">
                    <Button justIcon simple color="transparent" type="button">
                      <MoreHoriz
                        style={{
                          color: "#262626",
                        }}
                      />
                    </Button>
                  </Tooltip>
                </div>

                {/* =================================================
                    PRODUCT IMAGE
                ================================================= */}

                <div style={imageWrapperStyle}>
                  {post.image ? (
                    <img
                      src={post.image}
                      alt={`${post.company || "Company"} offer`}
                      style={imageStyle}
                      onLoad={(event) => handleImageLoad(event, post.id)}
                      onError={() => {
                        setRibbonColors((previous) => ({
                          ...previous,
                          [post.id]: "rgba(0, 0, 0, 0.55)",
                        }));
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#777777",
                      }}
                    >
                      Image unavailable
                    </div>
                  )}

                  {/* TOP RIBBON */}

                  <div
                    style={{
                      ...ribbonTopStyle,
                      background:
                        ribbonColors[post.id] || "rgba(0, 0, 0, 0.55)",
                    }}
                  >
                    Metal ₹ {post.metal || 0} + Making ₹ {post.making || 0}
                  </div>

                  {/* BOTTOM OFFER */}

                  {isOfferActive && post.offer && (
                    <div style={ribbonBottomStyle}>{post.offer}</div>
                  )}

                  {/* CATEGORY */}

                  <div style={ribbonCategoryStyle}>
                    {post.category || ""}
                    <br />
                    {post.sizemm || ""}
                  </div>
                </div>

                {/* =================================================
                    ACTIONS
                ================================================= */}

                <div style={actionsRowStyle}>
                  <div style={leftActionsStyle}>
                    {/* LIKE */}
                    <div style={actionWithValueStyle}>
                      <Tooltip title="Like">
                        <Button
                          justIcon
                          simple
                          color="transparent"
                          type="button"
                          style={actionButtonStyle}
                        >
                          <FavoriteBorder style={actionIconStyle} />
                        </Button>
                      </Tooltip>

                      <span style={actionCountStyle}>
                        {Number(post.likes) || 0}
                      </span>
                    </div>

                    {/* COMMENTS */}
                    <div style={actionWithValueStyle}>
                      <Tooltip title="Comments">
                        <Button
                          justIcon
                          simple
                          color="transparent"
                          type="button"
                          onClick={() => openComments(post)}
                          style={actionButtonStyle}
                        >
                          <ChatBubbleOutline style={actionIconStyle} />
                        </Button>
                      </Tooltip>

                      <span style={actionCountStyle}>
                        {Number(post.comments) || 0}
                      </span>
                    </div>

                    {/* REPOST */}
                    <div style={actionWithValueStyle}>
                      <Tooltip title="Reposts">
                        <Button
                          justIcon
                          simple
                          color="transparent"
                          type="button"
                          style={actionButtonStyle}
                        >
                          <Repeat style={actionIconStyle} />
                        </Button>
                      </Tooltip>

                      <span style={actionCountStyle}>
                        {Number(post.reposts) || 0}
                      </span>
                    </div>

                    {/* SHARE */}
                    <div style={actionWithValueStyle}>
                      <Tooltip title="Share">
                        <Button
                          justIcon
                          simple
                          color="transparent"
                          type="button"
                          style={actionButtonStyle}
                        >
                          <ShareOutlined style={actionIconStyle} />
                        </Button>
                      </Tooltip>
                    </div>

                    {/* CALL */}
                    <div style={actionWithValueStyle}>
                      <Tooltip title="Call">
                        <Button
                          justIcon
                          simple
                          color="transparent"
                          type="button"
                          onClick={() =>
                            history.push({
                              pathname: `/admin/view-posts-list`,
                              state: post,
                            })
                          }
                          style={actionButtonStyle}
                        >
                          <Phone style={actionIconStyle} />
                        </Button>
                      </Tooltip>

                      <span style={actionCountStyle}>
                        {Number(post.calls) || 0}
                      </span>
                    </div>

                    {/* WHATSAPP */}
                    <div style={actionWithValueStyle}>
                      <Tooltip title="WhatsApp">
                        <Button
                          justIcon
                          simple
                          color="transparent"
                          type="button"
                          style={actionButtonStyle}
                        >
                          <WhatsApp
                            style={{
                              ...actionIconStyle,
                              color: "#25D366",
                            }}
                          />
                        </Button>
                      </Tooltip>

                      <span style={actionCountStyle}>
                        {Number(post.whatsapps) || 0}
                      </span>
                    </div>

                    {/* SAVE */}
                    <div style={actionWithValueStyle}>
                      <Tooltip title="Save">
                        <Button
                          justIcon
                          simple
                          color="transparent"
                          type="button"
                          style={actionButtonStyle}
                        >
                          <BookmarkBorder style={actionIconStyle} />
                        </Button>
                      </Tooltip>

                      <span style={actionCountStyle}>
                        {Number(post.save) || 0}
                      </span>
                    </div>
                  </div>
                </div>

                {/* =================================================
                    CAPTION
                ================================================= */}

                <CardBody
                  style={{
                    paddingTop: 10,
                    paddingRight: 16,
                    paddingBottom: 12,
                    paddingLeft: 16,
                    margin: 0,
                    boxSizing: "border-box",
                  }}
                >
                  <div style={captionStyle}>
                    <span
                      style={{
                        fontWeight: 600,
                        marginRight: 5,
                      }}
                    >
                      {post.company || "Company"}
                    </span>

                    {post.description || ""}
                  </div>

                  <span>
                    {post.category || ""}

                    {post.category || post.sizemm ? ", " : ""}

                    {post.sizemm || ""}

                    {post.metalGram !== undefined
                      ? `, Metal Gram ${post.metalGram}`
                      : ""}

                    {post.readyGram !== undefined
                      ? `, Ready Gram ${post.readyGram}`
                      : ""}
                  </span>

                  {post.hashtag && (
                    <div style={hashtagStyle}>{post.hashtag}</div>
                  )}
                  <span style={timeStyle}>{timeAgo}</span>
                </CardBody>
              </Card>
            </GridItem>
          );
        })}
      </GridContainer>

      {/* =========================================================
          COMMENTS DIALOG
      ========================================================= */}

      <Dialog
        open={commentDialogOpen}
        onClose={closeComments}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          style: {
            width: "100%",
            maxWidth: 600,
            borderRadius: 12,
            overflow: "hidden",
          },
        }}
      >
        {/* DIALOG HEADER */}
        <DialogTitle
          style={{
            padding: "14px 18px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>
              <div
                style={{
                  fontSize: 18,
                  fontWeight: 700,
                  color: "#262626",
                }}
              >
                Comments
              </div>

              {selectedPost && (
                <div
                  style={{
                    fontSize: 12,
                    color: "#888888",
                    marginTop: 3,
                  }}
                >
                  {selectedPost.company || "Company"}
                </div>
              )}
            </div>

            <IconButton
              onClick={closeComments}
              size="small"
              aria-label="Close comments"
            >
              <Close />
            </IconButton>
          </div>
        </DialogTitle>

        <Divider />

        {/* COMMENT LIST */}
        <DialogContent
          style={{
            padding: "8px 14px",
            maxHeight: 500,
            overflowY: "auto",
          }}
        >
          {commentsLoading ? (
            <div
              style={{
                minHeight: 220,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress size={30} />
            </div>
          ) : comments.length === 0 ? (
            <div
              style={{
                minHeight: 220,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                color: "#888888",
              }}
            >
              <ChatBubbleOutline
                style={{
                  fontSize: 42,
                  marginBottom: 10,
                  color: "#bbbbbb",
                }}
              />

              <div
                style={{
                  fontSize: 14,
                  fontWeight: 600,
                }}
              >
                No comments yet
              </div>

              <div
                style={{
                  fontSize: 12,
                  marginTop: 4,
                }}
              >
                Be the first to comment.
              </div>
            </div>
          ) : (
            <div style={commentListStyle}>
              {comments.map((comment, index) => {
                const commentId =
                  comment.id ||
                  comment.commentId ||
                  comment.rId ||
                  `comment-${index}`;

                const commentUserName =
                  comment.userName || comment.company || "User";

                const commentTextValue = comment.comment || "";

                return (
                  <div
                    key={commentId}
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      width: "100%",
                      padding: "10px 4px",
                      borderBottom: "1px solid #eeeeee",
                      boxSizing: "border-box",
                    }}
                  >
                    {/* COMMENT CONTENT */}
                    <div
                      style={{
                        flex: 1,
                        minWidth: 0,
                        paddingRight: 5,
                      }}
                    >
                      {/* USER NAME */}
                      <div
                        style={{
                          fontSize: 13,
                          fontWeight: 700,
                          color: "#262626",
                        }}
                      >
                        {commentUserName}
                      </div>

                      {/* COMMENT TEXT */}
                      <div
                        style={{
                          fontSize: 13,
                          color: "#444444",
                          marginTop: 3,
                          lineHeight: "18px",
                          wordBreak: "break-word",
                        }}
                      >
                        {commentTextValue}
                      </div>

                      {/* DATE */}
                      {comment.createdAt && (
                        <div
                          style={{
                            fontSize: 10,
                            color: "#999999",
                            marginTop: 4,
                          }}
                        >
                          {new Date(comment.createdAt).toLocaleString()}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </DialogContent>

        <Divider />
      </Dialog>
    </div>
  );
}

ViewPosts.propTypes = {
  avatar: PropTypes.bool,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
};
